import React, { useContext } from 'react'
import '../Agreements/styles.scss'
import AgrDonutChart from './AgrDonutChart'
import usePortfolioName from '../../../../../hooks/usePortfolioName';
import { TagFilterContext } from '../../../../../context/TagFilterContext';
import HeaderExtended from '../HeaderExtended';
import { useTranslation } from 'react-i18next';
import { AgreementsData } from '../GeneralInformation/typesExtendedReport';
import { useAgreementsData } from './useAgreementsData';
import ReusableIcon from '../shared/ReusableIcon';

type agreementsProps = {
    data: AgreementsData | null | undefined;
    isLoan?: boolean;
    isTcp?: boolean;
    isIgr?: boolean;
    creationDate?: any;
    regions?: any;
    countries?: string;
    myPortfolio?: string;
    filtersApplied?: any;
}
const Agreements: React.FC<agreementsProps> = ({ data, isLoan, isTcp, isIgr, creationDate, regions, myPortfolio, filtersApplied }) => {
    const { t } = useTranslation();
    const portfolioName = usePortfolioName();
    const { labels } = useContext(TagFilterContext);
    const titleLon = 'LON';
    const titleTcp = 'TCP';
    const titleIgr = 'IGR';
    const mp = useAgreementsData(data);
    if (!data || !mp) return null;

    return (
        <>
            <div className='agr-content c-main'>
                <HeaderExtended
                    portfolioName={portfolioName}
                    filtersApplied={filtersApplied ?? labels}
                    creationDate={creationDate}
                    regions={regions}
                    myPortfolio={myPortfolio}
                />
                <div className='agr-sections'>
                    <header className="header-content">
                        <p>{t('extended_report.agr_agreements')}</p>
                        <div className='flex-avatars'>
                            {(isLoan) && (<ReusableIcon title={titleLon} color="#BE86D8" />)}
                            {(isTcp) && (<ReusableIcon title={titleTcp} color="#66B6B6" />)}
                            {(isIgr) && (<ReusableIcon title={titleIgr} color="#F1AF43" />)}
                        </div>
                    </header>
                    <section className='card-agreements'>
                        <p className='title-agreements-sections'>{t('extended_report.expiring_and_expired_agreements')}</p>
                        <div className='donut-flex'>
                            <div><AgrDonutChart label={titleLon} subtitle={t('extended_report.agr_totals')} count={mp.Lon.accordancesExpiring.counTotalAccordances} expired={mp.Lon.accordancesExpiring.expiration} nextToExp={mp.Lon.accordancesExpiring.nextToExpiration} /></div>
                            <div><AgrDonutChart label={titleTcp} subtitle={t('extended_report.agr_totals')} count={mp.Tcp.accordancesExpiring.counTotalAccordances} expired={mp.Tcp.accordancesExpiring.expiration} nextToExp={mp.Tcp.accordancesExpiring.nextToExpiration} /></div>
                            <div><AgrDonutChart label={titleIgr} subtitle={t('extended_report.agr_totals')} count={mp.Igr.accordancesExpiring.counTotalAccordances} expired={mp.Igr.accordancesExpiring.expiration} nextToExp={mp.Igr.accordancesExpiring.nextToExpiration} /></div>
                        </div>
                    </section>
                    <section className='card-agreements'>
                        <p className='title-agreements-sections'>{t('extended_report.agreements_pending_approval')}</p>
                        <div className='donut-flex'>
                            <div><AgrDonutChart label={titleLon} subtitle={t('extended_report.agr_totals')} count={mp.Lon.accordancesWaitingApproval.countTotalAccordances} expired={mp.Lon.accordancesWaitingApproval.expired} nextToExp={mp.Lon.accordancesWaitingApproval.nextToExpiration} /></div>
                            <div><AgrDonutChart label={titleTcp} subtitle={t('extended_report.agr_totals')} count={mp.Tcp.accordancesWaitingApproval.countTotalAccordances} expired={mp.Tcp.accordancesWaitingApproval.expired} nextToExp={mp.Tcp.accordancesWaitingApproval.nextToExpiration} /></div>
                            <div><AgrDonutChart label={titleIgr} subtitle={t('extended_report.agr_totals')} count={mp.Igr.accordancesWaitingApproval.countTotalAccordances} expired={mp.Igr.accordancesWaitingApproval.expired} nextToExp={mp.Igr.accordancesWaitingApproval.nextToExpiration} /></div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
}

export default Agreements